"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckToolsVisibility = void 0;
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
const PreferencesContext_1 = require("../context/PreferencesContext");
const ToolTypes_1 = require("../toolbar/ToolTypes");
const useCheckExperimentalFeature_1 = __importDefault(require("./useCheckExperimentalFeature"));
const useSpectrum_1 = __importDefault(require("./useSpectrum"));
function useCheckToolsVisibility() {
    const { displayerMode } = (0, ChartContext_1.useChartData)();
    const preferences = (0, PreferencesContext_1.usePreferences)();
    const spectrum = (0, useSpectrum_1.default)(null);
    const isExperimentalFeatureActivated = (0, useCheckExperimentalFeature_1.default)();
    return (0, react_1.useCallback)((toolKey, checkOptions = {}) => {
        const { checkMode = true, checkSpectrumType = true, extraInfoCheckParameters, } = checkOptions;
        const { spectraOptions, mode, isExperimental } = ToolTypes_1.options[toolKey];
        const flag = (0, get_1.default)(preferences.current, `display.toolBarButtons.${toolKey}`, false);
        const modeFlag = !checkMode || (checkMode && (!mode || displayerMode === mode));
        const spectrumCheckFlag = !checkSpectrumType ||
            (checkSpectrumType && checkSpectrum(spectrum, spectraOptions));
        const isToolActivated = (flag && !isExperimental) ||
            (isExperimental && isExperimentalFeatureActivated);
        return (isToolActivated &&
            modeFlag &&
            spectrumCheckFlag &&
            (!extraInfoCheckParameters ||
                checkInfo(extraInfoCheckParameters, spectrum?.info)));
    }, [displayerMode, isExperimentalFeatureActivated, preferences, spectrum]);
}
exports.useCheckToolsVisibility = useCheckToolsVisibility;
function checkSpectrum(spectrum, options) {
    let outerConditionResult = false;
    if (!options) {
        return true;
    }
    for (const option of options) {
        let innerConditionFlag = true;
        if (option.active) {
            if (spectrum) {
                for (const { key, value } of option.info || []) {
                    if (spectrum.info[key] !== value) {
                        innerConditionFlag = false;
                    }
                }
            }
            else {
                innerConditionFlag = false;
            }
        }
        outerConditionResult = outerConditionResult || innerConditionFlag;
    }
    return outerConditionResult;
}
function checkInfo(checkParameters, data) {
    for (const key in checkParameters) {
        if (checkParameters[key] !== data[key]) {
            return false;
        }
    }
    return true;
}
